import '@fontsource-variable/figtree'
import '@fontsource-variable/bricolage-grotesque/wght.css'
import '@fontsource/noto-sans-malayalam/malayalam-600.css'
import '@fontsource/outfit/latin-700.css'
import './styles/global.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app/App'
import { logAppOpen } from './features/activity/appOpen'
import { rememberCampaign } from './features/activity/campaign'
import { flushSeen } from './features/activity/seen'
import { onBeforeHide, startTracker } from './features/activity/tracker'
import { listenForInstall } from './features/pwa/install'
import { reloadForNewVersion } from './lib/staleChunk'

rememberCampaign() // before the first event: a campaign link credits this visit (BR-31)
startTracker()
onBeforeHide(flushSeen)
logAppOpen()
listenForInstall()
// A shared chunk of the previous deploy is gone: reload into the new version (once).
window.addEventListener('vite:preloadError', (e) => {
  if (reloadForNewVersion()) e.preventDefault()
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
